import React from 'react';
import { ClickAwayListener, Collapse, Grid, Paper } from '@mui/material';
import { useDialog, useResize } from 'hooks/common';
import SparkTextField, { SparkTextFieldProps } from '../SparkTextField';

type SparkFormPopupTextFieldProps = {
  children: React.ReactNode;
} & SparkTextFieldProps;

function SparkFormPopupTextField({
  children,
  ...rest
}: SparkFormPopupTextFieldProps) {
  const textFieldRef = React.useRef<HTMLDivElement | null>(null);
  const { open, openDialog, closeDialog } = useDialog();
  const { isMobile } = useResize();

  const defaultSize = rest.size || (isMobile ? 12 : 6);

  const textFieldRect = textFieldRef.current?.getBoundingClientRect();
  const textFieldTopOffset = textFieldRect?.top;

  return (
    <ClickAwayListener onClickAway={closeDialog}>
      <Grid item xs={defaultSize} container direction='column'>
        <SparkTextField
          {...rest}
          size={12}
          ref={textFieldRef}
          onFocus={openDialog}
        />
        <Collapse
          in={open}
          sx={{
            position: 'absolute',
            top: (textFieldTopOffset || 0) - 24,
            zIndex: 2,
          }}
          unmountOnExit={true}
        >
          <Paper elevation={2} sx={{ overflow: 'hidden' }}>
            <Grid
              container
              bgcolor={(theme) => theme.palette.common.white}
              borderRadius='10px'
              width={textFieldRef.current?.offsetWidth}
              onClick={closeDialog}
            >
              {children}
            </Grid>
          </Paper>
        </Collapse>
      </Grid>
    </ClickAwayListener>
  );
}

export default SparkFormPopupTextField;
